import * as SentryReact from "@sentry/react";

export const captureSentryException = SentryReact.captureException;
export const captureSentryMessage = SentryReact.captureMessage;
export const captureSentryEvent = SentryReact.captureEvent;
export const addSentryBreadcrumb = SentryReact.addBreadcrumb;

export const Sentry = {
  captureException: captureSentryException,
  captureMessage: captureSentryMessage,
  captureEvent: captureSentryEvent,
  addBreadcrumb: addSentryBreadcrumb,
};
